import * as actionTypes from '../actions';

var initialState = {
    isLoading: false,
    sessionExpired: false,
    allTranscation: [],
    allSellers: [],
    Transcationcount: 0,
    Sellerscount: 0,
    sellersNext: null,
    getTranscationError: '',
    getSellersError: '',
    graphDetails: [],
    graphDetailsError: '',
    transactionNext: '',
    isFaild: false,
    getWayHDFC: [],
    isHDFC: false,
    openPayDialog: false,
    van: null,
    invoiceNumber: null,
    allSubscriptions: [],
    SubscriptionsCount: 0,
    getSubscriptionError: '',
    subscriptionNext: '',
    currentSubscription: null,
    nonAutoPaySubscriptions: [],
    nonAutoPayCount: 0,
    nonAutoPayNext: '',
    allAssetsForFilter: [],
    assetsCount: 0,
    assetsNext: null,
    cancelAutoPayMessage: null,
    cancelAutoPayError: null,
    setupAutopayLoading: false,
    setupAutopayData: null,
    setupAutopayError: null,
    subscriptionDueList: [],
    subscriptionDueCount: 0,
    subscriptionDueLoading: false,
    subscriptionDueError: null,
    partnerDueList: [],
    partnerDueCount: 0,
    partnerDueLoading: false,
    partnerDueError: null,
    paymentOverview: null,
    paymentOverviewLoading: false,
    paymentOverviewError: null,
    partnerOverview: null,
    partnerOverviewLoading: false,
    partnerOverviewError: null,
    paymentActivityList: [],
    paymentActivityCount: 0,
    paymentActivityNext: null,
    paymentActivityPrevious: null,
    paymentActivityLoading: false,
    paymentActivityError: null,
    revenueSummary: null,
    revenueSummaryLoading: false,
    revenueSummaryError: null,
    totalFuelPurchase: null,
    totalFuelPurchaseLoading: false,
    totalFuelPurchaseError: null,
    partnerTotalFuelPurchase: null,
    partnerTotalFuelPurchaseLoading: false,
    partnerTotalFuelPurchaseError: null,
    partnerCreditUtilisation: null,
    partnerCreditUtilisationLoading: false,
    partnerCreditUtilisationError: null,
    partnerLimitUpgradeRequest: null,
    partnerLimitUpgradeLoading: false,
    partnerLimitUpgradeError: null,
    partnerLimitUpgradeSubmitting: false,
    creditPartnersList: [],
    creditPartnersListLoading: false,
    creditPartnersListError: null,
    invoiceAgeing: null,
    invoiceAgeingLoading: false,
    invoiceAgeingError: null,
    verifyPaymentAmountLoading: false,
    verifyPaymentAmountData: null,
    verifyPaymentAmountError: null,
};

const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PAYMENT_LOADING: {
            return {
                ...state,
                isLoading: true,
                sessionExpired: false,
            };
        }
        case actionTypes.PAYMENT_HDFC: {
            return {
                ...state,
                isHDFC: true,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_TRANSCATION_LIST: {
            return {
                ...state,
                isLoading: false,
                allTranscation: state?.allTranscation?.concat(action.payload?.results),
                Transcationcount: action.payload?.count,
                sessionExpired: false,
                transactionNext: action?.payload?.next
            };
        }
        case actionTypes.GET_TRANSCATION_LIST_FAIL: {
            return {
                ...state,
                getTranscationError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_SELLERS_LIST: {
            return {
                ...state,
                isLoading: false,
                allSellers: action.fetchMore
                    ? (state.allSellers || []).concat(action.payload?.results || [])
                    : (action.payload?.results || []),
                Sellerscount: action.payload?.count || 0,
                sellersNext: action.payload?.next || null,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_SELLERS_LIST_FAIL: {
            return {
                ...state,
                getSellersError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_GRAPH_DETAILS: {
            return {
                ...state,
                graphDetails: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_GRAPH_DETAILS_FAIL: {
            return {
                ...state,
                graphDetailsError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_PAYMENT_BEHAVIOUR: {
            return {
                ...state,
                paymentBehaviour: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_PAYMENT_BEHAVIOUR_FAIL: {
            return {
                ...state,
                paymentBehaviourError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_ORDER_REPORT: {
            return {
                ...state,
                paymentBehaviour: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_ORDER_REPORT_FAIL: {
            return {
                ...state,
                paymentBehaviourError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_HDFC_URL_DATA: {
            return {
                ...state,
                getWayHDFC: action.payload,
                isHDFC: false,
                sessionExpired: false,
                openPayDialog: true,
                isFaild: true,
            };
        }
        case actionTypes.GET_HDFC_URL_FAIL: {
            return {
                ...state,
                isFaild: true,
                sessionExpired: false,
                isHDFC: false,
            };
        }
        case actionTypes.CLEAR_TRANSATIONS: {
            return {
                ...state,
                isLoading: true,
                allTranscation: [],
            };
        }
        case actionTypes.CLOSE_HDFC_DIALOG: {
            return {
                ...state,
                openPayDialog: false,
            };
        }
        case actionTypes.STORE_VAN_INVOICE: {
            return {
                ...state,
                van: action.payload.van,
                invoiceNumber: action.payload.invoiceNumber,
            };
        }
        case actionTypes.GET_SUBSCRIPTION_LIST: {
            return {
                ...state,
                isLoading: false,
                allSubscriptions: action.fetchMoreData
                    ? (state.allSubscriptions || []).concat(action.payload?.results || [])
                    : (action.payload?.results || []),
                SubscriptionsCount: action.payload?.count,
                subscriptionNext: action?.payload?.next,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_SUBSCRIPTION_LIST_FAIL: {
            return {
                ...state,
                getSubscriptionError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_SUBSCRIPTION_BY_ID: {
            return {
                ...state,
                isLoading: false,
                currentSubscription: action.payload?.results?.[0] || action.payload?.results || action.payload,
                getSubscriptionError: null,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_SUBSCRIPTION_BY_ID_FAIL: {
            return {
                ...state,
                getSubscriptionError: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case 'SUBSCRIPTION_LOADING': {
            return {
                ...state,
                isLoading: !action.payload, // payload: false means loading = true
                getSubscriptionError: null,
            };
        }
        case actionTypes.GET_NON_AUTOPAY_SUBSCRIPTIONS: {
            return {
                ...state,
                isLoading: false,
                nonAutoPaySubscriptions: action.fetchMoreData
                    ? (state.nonAutoPaySubscriptions || []).concat(action.payload?.results || [])
                    : (action.payload?.results || []),
                nonAutoPayCount: action.payload?.count || 0,
                nonAutoPayNext: action.payload?.next || null,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_NON_AUTOPAY_SUBSCRIPTIONS_FAIL: {
            return {
                ...state,
                isLoading: false,
                getSubscriptionError: action.payload,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_ASSETS_FOR_FILTER: {
            return {
                ...state,
                isLoading: false,
                // append or replace depending on fetchMoreData
                allAssetsForFilter: action.fetchMoreData
                    ? [...(state.allAssetsForFilter || []), ...(action.payload?.results || [])]
                    : (action.payload?.results || []),
                assetsCount: action.payload?.count || 0,
                assetsNext: action.payload?.next || null,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_ASSETS_FOR_FILTER_FAIL: {
            return {
                ...state,
                isLoading: false,
                getAssetsError: action.payload,
                sessionExpired: false,
            };
        }
        case actionTypes.CANCEL_AUTOPAY_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                cancelAutoPayMessage: action.payload?.data || "AutoPay Cancelled Successfully",
                sessionExpired: false,
            };
        }
        case actionTypes.CANCEL_AUTOPAY_FAIL: {
            return {
                ...state,
                isLoading: false,
                cancelAutoPayError: action.payload,
                sessionExpired: false,
            };
        }
        case actionTypes.SETUP_AUTOPAY_REQUEST: {
            return {
                ...state,
                setupAutopayLoading: true,
                setupAutopayError: null,
                setupAutopayData: null,
            };
        }
        case actionTypes.SETUP_AUTOPAY_SUCCESS: {
            return {
                ...state,
                setupAutopayLoading: false,
                setupAutopayData: action.payload,
                sessionExpired: false,
            };
        }
        case actionTypes.SETUP_AUTOPAY_FAIL: {
            return {
                ...state,
                setupAutopayLoading: false,
                setupAutopayError: action.payload,
                sessionExpired: false,
            };
        }
        case actionTypes.CLEAR_NON_AUTOPAY_SUBSCRIPTIONS: {
            return {
                ...state,
                nonAutoPaySubscriptions: [],
                nonAutoPayCount: 0,
                nonAutoPayNext: null,
            };
        }
        case actionTypes.CLEAR_SUBSCRIPTIONS: {
            return {
                ...state,
                allSubscriptions: [],
                SubscriptionsCount: 0,
                subscriptionNext: null,
                currentSubscription: null,
            };
        }

        case 'SUBSCRIPTION_DUE_LOADING': {
            return {
                ...state,
                subscriptionDueLoading: true,
                subscriptionDueError: null,
            };
        }
        case actionTypes.GET_SUBSCRIPTION_DUE_LIST: {
            return {
                ...state,
                subscriptionDueLoading: false,
                subscriptionDueList: action.payload?.results || [],
                subscriptionDueCount: action.payload?.count || 0,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_SUBSCRIPTION_DUE_LIST_FAIL: {
            return {
                ...state,
                subscriptionDueLoading: false,
                subscriptionDueError: action.payload,
                sessionExpired: false,
            };
        }

        case 'PARTNER_DUE_LOADING': {
            return {
                ...state,
                partnerDueLoading: true,
                partnerDueError: null,
            };
        }
        case actionTypes.GET_PARTNER_DUE_LIST: {
            return {
                ...state,
                partnerDueLoading: false,
                partnerDueList: action.payload?.results || [],
                partnerDueCount: action.payload?.count || 0,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_PARTNER_DUE_LIST_FAIL: {
            return {
                ...state,
                partnerDueLoading: false,
                partnerDueError: action.payload,
                sessionExpired: false,
            };
        }

        case actionTypes.PAYMENT_OVERVIEW_LOADING: {
            return {
                ...state,
                paymentOverviewLoading: true,
                paymentOverviewError: null,
            };
        }
        case actionTypes.GET_PAYMENT_OVERVIEW: {
            return {
                ...state,
                paymentOverviewLoading: false,
                paymentOverview: action.payload || null,
                paymentOverviewError: null,
            };
        }
        case actionTypes.GET_PAYMENT_OVERVIEW_FAIL: {
            return {
                ...state,
                paymentOverviewLoading: false,
                paymentOverviewError: action.payload || null,
            };
        }

        case actionTypes.PARTNER_OVERVIEW_LOADING: {
            return {
                ...state,
                partnerOverview: null,
                partnerOverviewLoading: true,
                partnerOverviewError: null,
            };
        }
        case actionTypes.GET_PARTNER_OVERVIEW: {
            return {
                ...state,
                partnerOverviewLoading: false,
                partnerOverview: action.payload?.results?.[0] || action.payload || null,
                partnerOverviewError: null,
            };
        }
        case actionTypes.GET_PARTNER_OVERVIEW_FAIL: {
            return {
                ...state,
                partnerOverviewLoading: false,
                partnerOverviewError: action.payload || null,
            };
        }

        case actionTypes.PAYMENT_ACTIVITY_LOADING: {
            return {
                ...state,
                paymentActivityLoading: true,
                paymentActivityList: [],
                paymentActivityCount: 0,
                paymentActivityNext: null,
                paymentActivityPrevious: null,
                paymentActivityError: null,
            };
        }
        case actionTypes.GET_PAYMENT_ACTIVITY: {
            return {
                ...state,
                paymentActivityLoading: false,
                paymentActivityList: action.fetchMoreData
                    ? [...(state.paymentActivityList || []), ...(action.payload?.results || [])]
                    : (action.payload?.results || []),
                paymentActivityCount: action.payload?.count || 0,
                paymentActivityNext: action.payload?.next || null,
                paymentActivityPrevious: action.payload?.previous || null,
                paymentActivityError: null,
            };
        }
        case actionTypes.GET_PAYMENT_ACTIVITY_FAIL: {
            return {
                ...state,
                paymentActivityLoading: false,
                paymentActivityError: action.payload || null,
            };
        }

        case actionTypes.REVENUE_SUMMARY_LOADING: {
            return {
                ...state,
                revenueSummaryLoading: true,
                revenueSummaryError: null,
            };
        }
        case actionTypes.GET_REVENUE_SUMMARY: {
            return {
                ...state,
                revenueSummaryLoading: false,
                revenueSummary: action.payload || null,
                revenueSummaryError: null,
            };
        }
        case actionTypes.GET_REVENUE_SUMMARY_FAIL: {
            return {
                ...state,
                revenueSummaryLoading: false,
                revenueSummaryError: action.payload || null,
            };
        }

        case actionTypes.TOTAL_FUEL_PURCHASE_LOADING: {
            return {
                ...state,
                totalFuelPurchaseLoading: true,
                totalFuelPurchaseError: null,
            };
        }
        case actionTypes.GET_TOTAL_FUEL_PURCHASE: {
            return {
                ...state,
                totalFuelPurchaseLoading: false,
                totalFuelPurchase: action.payload || null,
                totalFuelPurchaseError: null,
            };
        }
        case actionTypes.GET_TOTAL_FUEL_PURCHASE_FAIL: {
            return {
                ...state,
                totalFuelPurchaseLoading: false,
                totalFuelPurchaseError: action.payload || null,
            };
        }

        case actionTypes.PARTNER_TOTAL_FUEL_PURCHASE_LOADING: {
            return {
                ...state,
                partnerTotalFuelPurchaseLoading: true,
                partnerTotalFuelPurchaseError: null,
            };
        }
        case actionTypes.GET_PARTNER_TOTAL_FUEL_PURCHASE: {
            return {
                ...state,
                partnerTotalFuelPurchaseLoading: false,
                partnerTotalFuelPurchase: action.payload?.results?.[0] || action.payload || null,
                partnerTotalFuelPurchaseError: null,
            };
        }
        case actionTypes.GET_PARTNER_TOTAL_FUEL_PURCHASE_FAIL: {
            return {
                ...state,
                partnerTotalFuelPurchaseLoading: false,
                partnerTotalFuelPurchaseError: action.payload || null,
            };
        }

        case actionTypes.PARTNER_CREDIT_UTILISATION_LOADING: {
            return {
                ...state,
                partnerCreditUtilisationLoading: true,
                partnerCreditUtilisationError: null,
            };
        }
        case actionTypes.GET_PARTNER_CREDIT_UTILISATION: {
            return {
                ...state,
                partnerCreditUtilisationLoading: false,
                partnerCreditUtilisation: action.payload?.results?.[0] || action.payload || null,
                partnerCreditUtilisationError: null,
            };
        }
        case actionTypes.GET_PARTNER_CREDIT_UTILISATION_FAIL: {
            return {
                ...state,
                partnerCreditUtilisationLoading: false,
                partnerCreditUtilisationError: action.payload || null,
            };
        }

        case actionTypes.PARTNER_LIMIT_UPGRADE_LOADING: {
            return {
                ...state,
                partnerLimitUpgradeRequest: null,
                partnerLimitUpgradeLoading: true,
                partnerLimitUpgradeError: null,
            };
        }
        case actionTypes.GET_PARTNER_LIMIT_UPGRADE: {
            return {
                ...state,
                partnerLimitUpgradeRequest: action.payload || null,
                partnerLimitUpgradeLoading: false,
                partnerLimitUpgradeError: null,
            };
        }
        case actionTypes.GET_PARTNER_LIMIT_UPGRADE_FAIL: {
            return {
                ...state,
                partnerLimitUpgradeLoading: false,
                partnerLimitUpgradeError: action.payload || null,
            };
        }
        case actionTypes.SUBMIT_PARTNER_LIMIT_UPGRADE_LOADING: {
            return {
                ...state,
                partnerLimitUpgradeSubmitting: true,
                partnerLimitUpgradeError: null,
            };
        }
        case actionTypes.SUBMIT_PARTNER_LIMIT_UPGRADE: {
            return {
                ...state,
                partnerLimitUpgradeSubmitting: false,
                partnerLimitUpgradeRequest: {
                    ...(state.partnerLimitUpgradeRequest || {}),
                    ...(action.payload || {}),
                    request_status: action.payload?.request_status || 'Pending',
                },
                partnerLimitUpgradeError: null,
            };
        }
        case actionTypes.SUBMIT_PARTNER_LIMIT_UPGRADE_FAIL: {
            return {
                ...state,
                partnerLimitUpgradeSubmitting: false,
                partnerLimitUpgradeError: action.payload || null,
            };
        }

        case actionTypes.CREDIT_PARTNERS_LIST_LOADING: {
            return {
                ...state,
                creditPartnersList: [],
                creditPartnersListLoading: true,
                creditPartnersListError: null,
            };
        }
        case actionTypes.GET_CREDIT_PARTNERS_LIST: {
            return {
                ...state,
                creditPartnersListLoading: false,
                creditPartnersList: action.payload?.results || action.payload?.items || action.payload || [],
                creditPartnersListError: null,
            };
        }
        case actionTypes.GET_CREDIT_PARTNERS_LIST_FAIL: {
            return {
                ...state,
                creditPartnersListLoading: false,
                creditPartnersListError: action.payload || null,
            };
        }

        case actionTypes.INVOICE_AGEING_LOADING: {
            return {
                ...state,
                invoiceAgeingLoading: true,
                invoiceAgeingError: null,
            };
        }
        case actionTypes.GET_INVOICE_AGEING: {
            return {
                ...state,
                invoiceAgeingLoading: false,
                invoiceAgeing: action.payload || null,
                invoiceAgeingError: null,
            };
        }
        case actionTypes.GET_INVOICE_AGEING_FAIL: {
            return {
                ...state,
                invoiceAgeingLoading: false,
                invoiceAgeingError: action.payload || null,
            };
        }

        case actionTypes.VERIFY_PAYMENT_AMOUNT_LOADING: {
            return {
                ...state,
                verifyPaymentAmountLoading: true,
                verifyPaymentAmountError: null,
            };
        }
        case actionTypes.VERIFY_PAYMENT_AMOUNT: {
            return {
                ...state,
                verifyPaymentAmountLoading: false,
                verifyPaymentAmountData: action.payload || null,
                verifyPaymentAmountError: null,
            };
        }
        case actionTypes.VERIFY_PAYMENT_AMOUNT_FAIL: {
            return {
                ...state,
                verifyPaymentAmountLoading: false,
                verifyPaymentAmountError: action.payload || null,
            };
        }

        default: {
            return state;
        }
    }
};

export default paymentReducer;
